'use client';
import { useEffect, useRef, useState } from 'react';
import { VirtualScrollProps } from './types';
import { useVirtualScroll } from './useVirtualScroll';

export const VirtualScroll = ({
  items,
  itemHeight,
  renderItem,
  containerHeight
}: Readonly<VirtualScrollProps>) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [actualHeight, setActualHeight] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      setActualHeight(containerRef.current.clientHeight);
    }
  }, []);

  const {
    items: virtualItems,
    totalHeight,
    onScroll
  } = useVirtualScroll({
    totalItems: items.length,
    itemHeight,
    containerHeight: actualHeight
  });

  return (
    <div
      className="overflow-y-auto"
      onScroll={onScroll}
      ref={containerRef}
      style={{ height: containerHeight }}
    >
      <div style={{ height: totalHeight, position: 'relative' }}>
        {virtualItems.map(({ index, offsetTop }) => (
          <div
            key={index}
            style={{
              position: 'absolute',
              top: 0,
              transform: `translateY(${offsetTop}px)`,
              width: '100%',
              height: itemHeight
            }}
          >
            {renderItem(items[index])}
          </div>
        ))}
      </div>
    </div>
  );
};
